let cctypes = ["Full Service", "Single Service"];
export default cctypes;
